import { tv } from 'tailwind-variants';

import { buttons } from './buttons';

export const dialogStyles = tv({
  base: [
    'shadow-30',
    'font-body',
    'h-full',
    'm-auto',
    'max-h-full',
    'max-w-full',
    'overflow-auto',
    '[&::-webkit-scrollbar]:hidden',
    '[-ms-overflow-style:none]',
    '[scrollbar-width:none]',
    'pointer-events-auto',
    'relative',
    'w-full',
    'bg-special-background-modal',
  ],
  variants: {
    size: {
      default: ['tablet:w-[480px]'],
      medium: ['tablet:w-[360px]'],
      large: ['tablet:w-[590px]'],
      xlarge: ['tablet:w-[840px]'],
    },
    variant: {
      default: [
        'rounded-none',
        'tablet:rounded-[1.25rem]',
        'h-full',
        'tablet:h-auto',
        'tablet:max-h-[80dvh]',
      ],
      bottomPanel: ['rounded-t-2xl h-auto mb-0 touch-none focus:outline-none'],
    },
  },
  defaultVariants: {
    size: 'default',
    variant: 'default',
  },
});

export const dialogCloseBtnStyles = tv({
  slots: {
    button: [
      buttons({
        color: 'transparent',
        shape: 'rounded',
        size: 'small',
        iconOnly: true,
      }),
    ],
    icon: ['block', 'h-4', 'w-4'],
  },
  variants: {
    absolute: {
      true: {
        button: ['absolute', 'right-3', 'top-3', 'z-1'],
      },
    },
  },
});

// Helper functions to maintain backward compatibility
const getDialogStyle = (
  size: 'default' | 'medium' | 'large' | 'xlarge',
  variant: 'default' | 'bottomPanel' = 'default',
) => {
  return dialogStyles({ size, variant });
};

// Predefined style combinations for easy use
export const dialogVariants = {
  DEFAULT: () => getDialogStyle('default'),
  MEDIUM: () => getDialogStyle('medium'),
  LARGE: () => getDialogStyle('large'),
  XLARGE: () => getDialogStyle('xlarge'),
  DEFAULT_BOTTOM_PANEL: () => getDialogStyle('default', 'bottomPanel'),
  LARGE_BOTTOM_PANEL: () => getDialogStyle('large', 'bottomPanel'),
};
